import React from "react";
import { Link } from "react-router-dom";
import { COMPANY, NAV, ZONES } from "@/data";

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-black border-t border-white/5 pt-20 pb-10 px-6 md:px-12"
  >
    <div className="max-w-[1500px] mx-auto">
      <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-white/5">
        <div className="md:col-span-5">
          <div className="mb-6" style={{ perspective: "1000px" }}>
            <img
              src="https://customer-assets.emergentagent.com/job_site-gen-40/artifacts/w8qlhov1_CAB43020-D96D-4806-BF75-FFC804326E21.png"
              alt="VistaWash"
              className="h-20 w-auto object-contain"
              style={{
                mixBlendMode: "screen",
                filter:
                  "drop-shadow(1px 1px 0 #ff3333) drop-shadow(2px 2px 0 #c00000) drop-shadow(3px 3px 0 #7a0000) drop-shadow(4px 4px 0 #4a0000) drop-shadow(5px 6px 14px rgba(217,0,0,0.55)) drop-shadow(8px 14px 28px rgba(0,0,0,0.9)) contrast(1.1) brightness(1.05)",
                transform: "perspective(1000px) rotateX(8deg) rotateY(-6deg)",
              }}
            />
          </div>
          <p className="font-display text-2xl md:text-3xl leading-tight max-w-md mb-8">
            L'atelier de detailing automobile premium de Châtelet & Charleroi.
          </p>
          <a
            href={COMPANY.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="inline-flex items-center gap-3 border border-white/15 hover:border-[#D90000] text-white text-[11px] uppercase tracking-[0.25em] font-semibold px-6 py-3 transition-colors"
          >
            WhatsApp · {COMPANY.phone_display}
          </a>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-6">
            Navigation
          </div>
          <ul className="space-y-3">
            {NAV.map((n) =>
              n.children ? (
                <React.Fragment key={n.label}>
                  {n.children.map((c) => (
                    <li key={c.to}>
                      <Link
                        to={c.to}
                        className="text-white/70 hover:text-[#D90000] transition-colors text-sm"
                      >
                        {c.label}
                      </Link>
                    </li>
                  ))}
                </React.Fragment>
              ) : (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-white/70 hover:text-[#D90000] transition-colors text-sm"
                  >
                    {n.label}
                  </Link>
                </li>
              )
            )}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-6">
            Contact
          </div>
          <ul className="space-y-3 text-white/70 text-sm">
            <li>{COMPANY.address_line1}</li>
            <li>{COMPANY.address_line2}</li>
            <li>
              <a href={COMPANY.phone_link} className="hover:text-white">
                {COMPANY.phone_display}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white">
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="py-10 border-b border-white/5">
        <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-5">
          Zones d'intervention
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/60">
          {ZONES.map((z) => (
            <span key={z}>{z}</span>
          ))}
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 text-[11px] uppercase tracking-[0.25em] text-white/30">
        <div>© {new Date().getFullYear()} VistaWash. Tous droits réservés.</div>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-mentions">
            Mentions légales
          </Link>
          <Link to="/politique-confidentialite" className="hover:text-white transition-colors" data-testid="footer-privacy">
            Confidentialité
          </Link>
          <Link to="/cgv" className="hover:text-white transition-colors" data-testid="footer-cgv">
            CGV
          </Link>
        </div>
        <div>Detailing automobile premium · Châtelet, Belgique</div>
      </div>
    </div>
  </footer>
);

export default Footer;
